const newEquipmentType = {
  snackbar: "Your update is ready",
  name: "Equipment Type Name",
  save: "Save",
  cancel: "Cancel",
  area: "Equipment Type",
  formTitle: "Equipment Type",
  isPump: "Is a pump?",
  confirm: "Are you sure you want to delete this item?",
  close: "Close",
  delete: "Delete"
};
export default newEquipmentType;
